<template>
    <div class="above-header">
        <span class="above-header__new">NEW</span><a target="_blank" :href="this.link">{{ this.content }}</a>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "AboveHeader",

        data: () => ({
            content: '',
            link: ''
        }),

        beforeMount() {
            axios.get('/customSiteContent/header?product=AT', {
                responseType: 'json'
            })
                .then(response => {
                    this.content = response.data.content;
                    this.link = response.data.link;
                })
                .catch(error => {
                    this.content = 'Get the most out of actiTIME with our helpful tips.';
                    this.link = '/getting-more-efficient-with-actitime';
                })
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/variables.scss';

    .above-header {
        position: relative;
        z-index: 10;
        width: 100%;
        min-height: 45px;
        background: $general-purple;
        box-shadow: 0px 7px 22px rgba(68, 65, 254, .15);
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        padding: 10px;

        a {
            color: white;
            text-align: center;

            &:hover {
                text-decoration: underline;
            }
        }

        &__new {
            background: linear-gradient(117.21deg, #FF3998 20.22%, #FF6C3E 86.27%);
			box-shadow: 0px 2px 5px rgba(127, 15, 215, 0.25);
			border-radius: 30px;
			color: #FFFFFF;
			padding: 3px 10px;
            font-size: 14px;
            margin-right: 10px;
            cursor: default;

            @media (max-width: 500px) {
                display: none;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/AboveHeader.vue